import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, XIcon, ChevronUpIcon, PhoneIcon } from 'lucide-react';
import { WhatsAppLogo } from './icons/WhatsAppLogo';
export const FixedCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Show the CTA after user has scrolled a bit
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    // Initial check for mobile
    checkMobile();
    // Initial check for scroll position
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  if (!isVisible) return null;
  // Mobile version
  if (isMobile) {
    return <div className="fixed bottom-0 left-0 right-0 z-50 animate-fadeIn" data-id="element-148" data-mp="a4r1u33kngo1">
        {/* Main CTA Bar */}
        <div className="bg-black/90 backdrop-blur-md border-t border-[#222] shadow-lg px-4 py-3 flex items-center justify-between" data-id="element-149" data-mp="e6cbzgoq1guj">
          {/* Afspraak maken button with gradient animation */}
          <Link to="/afspraak-maken" className="relative overflow-hidden rounded-md flex-1 mr-3" data-id="element-150" data-mp="16v1b5a67vc3n">
            <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] py-2.5 px-5 text-center animate-gradient-shift" data-id="element-151" data-mp="sv8pvudglo32">
              <span className="text-black font-medium text-sm uppercase" data-id="element-152" data-mp="xtaaijqj9vgn">
                Afspraak maken
              </span>
            </div>
          </Link>
          {/* Contact buttons container */}
          <div className="flex items-center space-x-2" data-id="element-153" data-mp="3illwiva7tur1">
            {/* WhatsApp Button */}
            <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-md bg-[#25D366] flex items-center justify-center shadow-md" aria-label="Contact via WhatsApp" data-id="element-154" data-mp="1o3an0wsfoobn">
              <WhatsAppLogo size={20} data-id="element-155" data-mp="1ed7uexp85cdu" />
            </a>
            {/* Phone Button */}
            <a href="tel:+31627888306" className="w-10 h-10 rounded-md bg-[#121212] border border-[#333] flex items-center justify-center" aria-label="Call us" data-id="element-156" data-mp="1abw74yttp38t">
              <PhoneIcon size={18} className="text-white" data-id="element-157" data-mp="10f172bhwiusf" />
            </a>
          </div>
        </div>
      </div>;
  }
  // Desktop version
  return <div className="fixed bottom-6 right-6 z-50 animate-fadeIn" data-id="element-158" data-mp="vgg78d6kad4i">
      {isExpanded ? <div className="bg-black/90 backdrop-blur-md border border-[#333] rounded-md shadow-xl overflow-hidden w-64" data-id="element-159" data-mp="reuyn4128l04">
          <div className="flex items-center justify-between p-3 border-b border-[#222]" data-id="element-160" data-mp="2psehmiglxf1z">
            <h3 className="text-white font-medium text-sm" data-id="element-161" data-mp="2lt5nhchnnf5w">Contact opties</h3>
            <button onClick={() => setIsExpanded(false)} className="text-white/60 hover:text-white p-1.5 rounded-md hover:bg-white/10 transition-all" aria-label="Close contact options" data-id="element-162" data-mp="7kv138bltg31">
              <XIcon size={16} data-id="element-163" data-mp="haej6brht5wu" />
            </button>
          </div>
          <div className="p-4 space-y-3" data-id="element-164" data-mp="hc94hr6of01g">
            <Link to="/afspraak-maken" className="relative overflow-hidden rounded-md block" data-id="element-165" data-mp="lc9hr8i1h56x">
              <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] py-2.5 px-4 text-center animate-gradient-shift" data-id="element-166" data-mp="3krejurj2eeak">
                <span className="text-black font-medium text-sm" data-id="element-167" data-mp="3pqhqggep0skn">
                  Afspraak maken
                </span>
              </div>
            </Link>
            <a href="https://wa.me/31627888306" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-[#25D366] hover:bg-[#25D366]/90 text-white font-medium text-sm py-2.5 px-4 rounded-md text-center transition-colors duration-300" data-id="element-168" data-mp="2lrtbg48ovrd">
              <WhatsAppLogo size={16} className="mr-2" data-id="element-169" data-mp="1e28bvib3bsig" />
              WhatsApp
            </a>
            <Link to="/contact" className="block bg-[#121212] hover:bg-[#1a1a1a] text-white font-medium text-sm py-2.5 px-4 rounded-md text-center transition-colors duration-300 border border-[#333]" data-id="element-170" data-mp="1clchdbdm3ay3">
              Vraag advies
            </Link>
          </div>
        </div> : <button onClick={() => setIsExpanded(true)} className="relative overflow-hidden rounded-md p-3 shadow-lg hover:shadow-[0_0_15px_rgba(214,40,31,0.3)] transition-all duration-300 group" aria-label="Open contact options" data-id="element-171" data-mp="1hhjjet2w02ar">
          <div className="bg-gradient-to-r from-[#FFD500] via-[#FF6B00] to-[#D6281F] absolute inset-0 animate-gradient-shift" data-id="element-172" data-mp="1qgwxjz1yhf1t"></div>
          <ChevronUpIcon size={20} className="relative z-10 text-black group-hover:animate-bounce" data-id="element-173" data-mp="208arlrb51mnk" />
        </button>}
    </div>;
};